"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructor_course_html_1 = __importDefault(require("./instructor-course.html"));
var instructor_course_controller_1 = __importDefault(require("./instructor-course.controller"));
var instructor_view_course_module_1 = __importDefault(require("./view/instructor-view-course.module"));
var instructor_course_attendance_module_1 = __importDefault(require("./attendance/instructor-course-attendance.module"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.course", {
        url: "/course/:courseId",
        abstract: true,
        template: instructor_course_html_1.default,
        controller: instructor_course_controller_1.default,
        controllerAs: "vm",
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.course", [
    instructor_course_attendance_module_1.default.name,
    instructor_view_course_module_1.default.name,
])
    .config(config)
    .controller("InstructorCourseController", instructor_course_controller_1.default);
